/* eslint-disable */
const formConfig = {
  title: 'Social Media Rate Card',
  sections: [
    {
      title: 'Instagram Section',
      class: 'col-xs-12 col-md-6',
      fields: [
        {
          label: 'Instagram Handle',
          name: 'instagramHandle',
          placeholder: '@handle',
          type: 'textbox',
          class: 'col-xs-12 col-md-12'
        },
        {
          label: 'Your IG Following Count',
          name: 'igFollowerCount',
          placeholder: '123000',
          type: 'normalNumber',
          class: 'col-xs-12 col-md-12',
          labelClass: 'follower-label'
        },
        // {
        //   label: 'Average Views',
        //   name: 'igAvgViews',
        //   placeholder: '',
        //   type: 'normalNumber',
        //   class: 'col-xs-12 col-md-12'
        // },
        {
          label: 'IG Story',
          name: 'igStory',
          type: 'number',
          prefix: 'SGD $',
          class: 'col-xs-12 col-md-12 d-flex flex-row pb-4',
          labelClass: 'label-stats'
        },
        {
          label: 'IG Post',
          name: 'igPost',
          type: 'number',
          prefix: 'SGD $',
          class: 'col-xs-12 col-md-12 d-flex flex-row pb-4',
          labelClass: 'label-stats'
        },
        {
          label: 'IG Carousel',
          name: 'igCarousel',
          type: 'number',
          prefix: 'SGD $',
          class: 'col-xs-12 col-md-12 d-flex flex-row pb-4',
          labelClass: 'label-stats'
        },
        {
          label: 'IG Reel',
          name: 'igReel',
          type: 'number',
          prefix: 'SGD $',
          class: 'col-xs-12 col-md-12 d-flex flex-row pb-4',
          labelClass: 'label-stats'
        },
        {
          label: 'Remarks (Instagram)',
          name: 'igRemarks',
          type: 'textarea',
          placeholder: '(e.g. Bundle Rate)',
          class: 'col-xs-12 col-md-12 pb-0'
        }
      ]
    },
    {
      title: 'TikTok Section',
      class: 'col-xs-12 col-md-6',
      fields: [
        {
          label: 'TikTok Handle',
          name: 'tiktokHandle',
          placeholder: '@handle',
          type: 'textbox',
          class: 'col-xs-12 col-md-12'
        },
        {
          label: 'Your TikTok Following Count',
          name: 'tiktokFollowerCount',
          placeholder: '456700',
          type: 'normalNumber',
          class: 'col-xs-12 col-md-12'
        },
        // {
        //   label: 'Average Views',
        //   name: 'tiktokAvgViews',
        //   placeholder: '',
        //   type: 'normalNumber',
        //   class: 'col-xs-12 col-md-12'
        // },
        {
          label: 'Tiktok',
          name: 'tiktok',
          type: 'number',
          prefix: 'SGD $',
          class: 'col-xs-12 col-md-12 d-flex flex-row pb-0',
          labelClass: 'label-stats'
        },
        {
          label: 'Remarks (TikTok)',
          name: 'tiktokRemarks',
          type: 'textarea',
          placeholder: '(e.g. Bundle Rate)',
          class: 'col-xs-12 col-md-12'
        }
      ]
    },
    {
      title: 'LinkedIn Section',
      class: 'col-xs-12 col-md-6',
      fields: [
        {
          label: 'LinkedIn Handle',
          name: 'linkedinHandle',
          placeholder: '@handle or LinkedIn profile URL',
          type: 'textbox',
          class: 'col-xs-12 col-md-12'
        },
        {
          label: 'Followers (Connections)',
          name: 'linkedinFollowerCount',
          placeholder: '123000',
          type: 'normalNumber',
          class: 'col-xs-12 col-md-12'
        },
        {
          label: 'LinkedIn Post',
          name: 'linkedin',
          type: 'number',
          prefix: 'SGD $',
          class: 'col-xs-12 col-md-12 d-flex flex-row pb-0',
          labelClass: 'label-stats'
        }
      ]
    },
    {
      title: 'X (Twitter) Section',
      class: 'col-xs-12 col-md-6',
      fields: [
        {
          label: 'X (Twitter) Handle',
          name: 'twitterHandle',
          placeholder: '@handle or x.com/handle',
          type: 'textbox',
          class: 'col-xs-12 col-md-12'
        },
        {
          label: 'X (Twitter) Followers',
          name: 'twitterFollowerCount',
          placeholder: '123000',
          type: 'normalNumber',
          class: 'col-xs-12 col-md-12'
        },
        {
          label: 'X (Twitter) Post',
          name: 'twitter',
          type: 'number',
          prefix: 'SGD $',
          class: 'col-xs-12 col-md-12 d-flex flex-row pb-0',
          labelClass: 'label-stats'
        }
      ]
    },
    {
      title: 'Facebook Section',
      class: 'col-xs-12 col-md-6',
      fields: [
        {
          label: 'Facebook Handle',
          name: 'facebookHandle',
          placeholder: '@handle or Facebook profile URL',
          type: 'textbox',
          class: 'col-xs-12 col-md-12'
        },
        {
          label: 'Facebook Followers',
          name: 'facebookFollowerCount',
          placeholder: '123000',
          type: 'normalNumber',
          class: 'col-xs-12 col-md-12'
        },
        {
          label: 'Facebook Post',
          name: 'facebook',
          type: 'number',
          prefix: 'SGD $',
          class: 'col-xs-12 col-md-12 d-flex flex-row pb-0',
          labelClass: 'label-stats'
        }
      ]
    },
    {
      title: 'YouTube Section',
      class: 'col-xs-12 col-md-6',
      fields: [
        {
          label: 'YouTube Handle',
          name: 'youtubeHandle',
          placeholder: '@handle or YouTube channel URL',
          type: 'textbox',
          class: 'col-xs-12 col-md-12'
        },
        {
          label: 'YouTube Followers',
          name: 'youtubeFollowerCount',
          placeholder: '123000',
          type: 'normalNumber',
          class: 'col-xs-12 col-md-12'
        },
        {
          label: 'YouTube Post',
          name: 'youtube',
          type: 'number',
          prefix: 'SGD $',
          class: 'col-xs-12 col-md-12 d-flex flex-row pb-0',
          labelClass: 'label-stats'
        }
      ]
    },
    {
      title: 'Twitch Section',
      class: 'col-xs-12 col-md-6',
      fields: [
        {
          label: 'Twitch Handle',
          name: 'twitchHandle',
          placeholder: '@handle or Twitch channel URL',
          type: 'textbox',
          class: 'col-xs-12 col-md-12'
        },
        {
          label: 'Twitch Followers',
          name: 'twitchFollowerCount',
          placeholder: '123000',
          type: 'normalNumber',
          class: 'col-xs-12 col-md-12'
        },
        {
          label: 'Twitch Post',
          name: 'twitch',
          type: 'number',
          prefix: 'SGD $',
          class: 'col-xs-12 col-md-12 d-flex flex-row pb-0',
          labelClass: 'label-stats'
        }
      ]
    },
    {
      title: 'Other Platforms Section',
      class: 'col-xs-12 col-md-12',
      fields: [
        {
          label: 'Add more platforms',
          type: 'multiple',
          name: 'platforms',
          class: 'col-xs-12 col-md-12',
          labelClass: 'more-platform-label',
          options: [
            {
              label: 'Platform',
              type: 'select',
              name: 'platform',
              divClass: 'platform-select',
              class: 'col-xs-12 col-md-4 platform-select pt-0',
              style: 'font-size: 12px;min-width: 100px;max-width: 120px;',
              options: [
                {
                  label: 'Others',
                  value: 'others'
                }
              ]
            },
            {
              label: 'URL',
              placeholder: 'URL',
              type: 'textarea',
              name: 'url',
              class: 'col-xs-12 col-md-4 pt-0'
            },
            {
              label: 'Rate',
              placeholder: 'Rate',
              type: 'number',
              name: 'rate',
              prefix: 'SGD $',
              class: 'px-1 multiple-rate',
              style: 'width:100%;position:absolute;margin-top:95px'
            },
            {
              type: 'delete',
              style: 'max-width:30px'
            }
          ],
          child: {
            label: 'Others',
            placeholder: 'If others, please specify',
            type: 'textbox',
            name: 'otherPlatform',
            parentName: 'platform',
            class: 'col-xs-12 col-md-4'
          }
        }
      ]
    },
    {
      title: 'Common Fees',
      class: 'col-xs-12 col-md-12',
      fields: [
        {
          label: 'Event Attendance Fee',
          name: 'eventAppearance',
          type: 'number',
          prefix: 'SGD $',
          class: 'col-xs-12 col-md-6 d-flex flex-row pb-4',
          labelClass: 'label-stats'
        },
        {
          label: 'Loading Fee',
          name: 'loadingFee',
          type: 'number',
          prefix: 'SGD $',
          class: 'col-xs-12 col-md-6 d-flex flex-row pb-4',
          labelClass: 'label-stats'
        }
      ]
    },
    {
      title: 'Global Section',
      class: 'col-xs-12 col-md-12',
      fields: [
        {
          label: `Media Kit`,
          name: 'uploadMediaKit',
          type: 'file',
          class: 'col-xs-12 col-md-12',
          style: 'max-width:800px'
        }
      ]
    }
  ]
}

const tableHeaders = [
  {
    text: 'Name',
    value: 'name',
    sortable: false
  },
  {
    text: 'Email',
    value: 'email',
    sortable: false
  },
  {
    text: 'Date of Birth',
    value: 'dateOfBirth',
    sortable: false
  },
  {
    text: 'Ethnicity',
    value: 'ethnicity',
    sortable: false
  },
  {
    text: 'Country',
    value: 'country',
    sortable: false
  },
  {
    text: 'City',
    value: 'city',
    sortable: false
  },
  {
    text: 'Gender',
    value: 'gender',
    sortable: false
  },
  {
    text: 'Contact Number',
    value: 'contactNo',
    sortable: false
  },
  {
    text: 'Instagram Handle',
    value: 'instagramHandle',
    sortable: false
  },
  {
    text: 'Instagram Followers',
    value: 'igFollowerCount',
    sortable: false
  },
  {
    text: 'TikTok Handle',
    value: 'tiktokHandle',
    sortable: false
  },
  {
    text: 'TikTok Followers',
    value: 'tiktokFollowerCount',
    sortable: false
  },
  {
    text: 'Youtube',
    value: 'youtube',
    sortable: false
  },
  {
    text: 'YouTube Followers',
    value: 'youtubeFollowerCount',
    sortable: false
  },
  {
    text: 'YouTube Post',
    value: 'youtubeRate',
    sortable: false
  },
  {
    text: 'Facebook',
    value: 'facebook',
    sortable: false
  },
  {
    text: 'Facebook Followers',
    value: 'facebookFollowerCount',
    sortable: false
  },
  {
    text: 'Facebook Post',
    value: 'facebookRate',
    sortable: false
  },
  {
    text: 'LinkedIn',
    value: 'linkedin',
    sortable: false
  },
  {
    text: 'Followers (Connections)',
    value: 'linkedinFollowerCount',
    sortable: false
  },
  {
    text: 'LinkedIn Post',
    value: 'linkedinRate',
    sortable: false
  },
  {
    text: 'X (Twitter)',
    value: 'twitter',
    sortable: false
  },
  {
    text: 'X (Twitter) Followers',
    value: 'twitterFollowerCount',
    sortable: false
  },
  {
    text: 'X (Twitter) Post',
    value: 'twitterRate',
    sortable: false
  },
  {
    text: 'Twitch',
    value: 'twitch',
    sortable: false
  },
  {
    text: 'Twitch Followers',
    value: 'twitchFollowerCount',
    sortable: false
  },
  {
    text: 'Twitch Post',
    value: 'twitchRate',
    sortable: false
  },
  {
    text: 'IG Story',
    value: 'igStory',
    sortable: false
  },
  {
    text: 'IG Post',
    value: 'igPost',
    sortable: false
  },
  {
    text: 'IG Carousel',
    value: 'igCarousel',
    sortable: false
  },
  {
    text: 'IG Reel',
    value: 'igReel',
    sortable: false
  },
  {
    text: 'IG Remarks',
    value: 'igRemarks',
    sortable: false
  },
  {
    text: 'TikTok',
    value: 'tiktok',
    sortable: false
  },
  {
    text: 'TikTok Remarks',
    value: 'tiktokRemarks',
    sortable: false
  },
  {
    text: 'Event Attendance',
    value: 'eventAppearance',
    sortable: false
  },
  {
    text: 'Loading Fee',
    value: 'loadingFee',
    sortable: false
  },
  {
    text: 'Media Kit',
    value: 'uploadMediaKit',
    sortable: false
  },
  {
		text: 'Preferred campaigns/genre',
		value: 'preferredCampaigns',
    sortable: false
	},
  {
    text: 'Genre/Keywords',
    value: 'labelDisplays',
    sortable: false
	},
  {
    text: 'Labels Edit',
    value: 'labels',
    sortable: false
	},
  {
		text: 'Profile short description',
		value: 'aboutYou',
    sortable: false
	},
  {
		text: 'Load Content Aggreement',
		value: 'loadContent',
    sortable: false
	},
  {
    text: 'Gifting Collaborations',
    value: 'giftBrand',
    sortable: false
	},  
  {
    text: 'Engagement',
    value: 'engagement',
    sortable: false
	},
  {
    text: 'Views',
    value: 'views',
    sortable: false
	},
  {
    text: 'CC Remarks',
    value: 'ccRemarks',
    sortable: false
	},
  {
    text: 'Updated On',
    value: 'updatedAt',
    sortable: false
  },
  {
    text: 'Actions',
    value: 'action',
    sortable: false
  }
]

const getRanges = (from, to) => {
  let range = {}
  if (from) {
    range.from = [
      ...from
    ]
  }
  if (to) {
    range.to = [
      ...to
    ]
  }
  return range
}
const followersCount = ['1K', '5K', '10K', '25K', '50K', '100K', '250K', '500K', '1M'];
const followerOptions = getRanges(followersCount, followersCount)

const rateCardLabels = [
  'Comedy/Roleplaying/Skit',
  'Music/Dance/Sing',
  'Lifestyle',
  'Travel/Places to visit',
  'Food',
  'Beauty & Personal Care',
  'Fashion',
  'Couple',
  'Health & Fitness/Sports',
  'Tech',
  'Gaming',
  'Finance',
  'Family & Parenting',
  'Entrepreneur/Business Owner',
  'Education / Lifehacks',
  'Home & Living',
  'Luxury'
]

const currencyOptions = [
  'SGD',
  'USD',
  'IDR',
  'PHP',
  'THB',
  'MYR',
  'VND'
]

const rateCardTermsAndCondition = {
  title: {
    en: 'Terms and Conditions',
    th: 'ข้อกำหนดและเงื่อนไข',
    vn: 'Các điều khoản và điều kiện',
    id: 'Syarat dan Ketentuan',
    cn: '条款与条件'
  },
  html: {
    en: `
    <ol>
      <li>I have read and accepted the terms of use (https://www.getkobe.com/infuencer-terms-use-agreement/)</li>
      <li>I warrant that I am not currently embroiled in any controversies or legal disputes that may negatively impact my reputation or the reputation of Kobe or its Clients. I further agree to conduct myself in a manner consistent with the values of professionalism, integrity, and decency. Kobe reserves the right to terminate any Campaign Agreement with Content Creators found to be in violation of this clause, and such termination may result in forfeiture of any compensation or benefits under the agreement.</li>
      <li>I agree that any content submitted to Kobe pursuant to a Campaign Agreement and accepted by a Client shall remain publicly accessible through your social media account(s) for a minimum of six (6) months, or such greater term as specifed in the Campaign Agreement.</li>
      <li>I own all of the content and information i create, in addition, the content that is covered by intellectual property rights, like photos and videos (IP content), You hereby represent and warrant that the content will be an original work of you and that the content will not infringe or misappropriate the intellectual property rights of any third party.</li>
      <li>I will submit my payout and all post statistics on https://app.getkobe.com/ once job has been completed in order for payment to be processed. Payment will be received within 45 days after payout submission on the platform and/or payment clearance from client, whichever earlier.</li>
      <li>Once I have received confirmation of the brief, I will submit all drafts in a timely manner and according to the requested guidelines from the client. I will ensure the post goes live by the date of deadline and understand if this is not met, or the client has any complaints about my performance, I may forfeit my rate or be deducted a penalty by the client.</li>
      <li>If products are incorporated within the campaign, they should not be included for the purpose of sale or resale.</li>
    </ol>`,
    th: `
    <ol>
      <li>ฉันได้อ่านและยอมรับข้อกำหนดการใช้งานแล้ว (https://www.getkobe.com/infuencer-terms-use-agreement/)</li>
      <li>ฉันรับประกันว่าขณะนี้ฉันไม่ได้พัวพันกับความขัดแย้งหรือข้อพิพาททางกฎหมายใด ๆ ที่อาจส่งผลเสียต่อชื่อเสียงของฉันหรือชื่อเสียงของ Kobe หรือลูกค้า ฉันยังตกลงที่จะประพฤติตนในลักษณะที่สอดคล้องกับค่านิยมของความเป็นมืออาชีพ ความซื่อสัตย์ และความเหมาะสม Kobe ขอสงวนสิทธิ์ในการยกเลิกข้อตกลงแคมเปญใด ๆ กับผู้สร้างเนื้อหาที่พบว่าละเมิดข้อกำหนดนี้ และการยุติดังกล่าวอาจส่งผลให้มีการริบค่าตอบแทนหรือผลประโยชน์ใด ๆ ภายใต้ข้อตกลง</li>
      <li>ฉันยอมรับว่าเนื้อหาใด ๆ ที่ส่งไปยัง Kobe ตามข้อตกลงแคมเปญและลูกค้ายอมรับจะยังคงเข้าถึงได้แบบสาธารณะผ่านบัญชีโซเชียลมีเดียของคุณเป็นเวลาอย่างน้อยหก (6) เดือนหรือระยะเวลาที่นานกว่านั้นตามที่ระบุไว้ใน ข้อตกลงการรณรงค์</li>
      <li>ฉันเป็นเจ้าของเนื้อหาและข้อมูลทั้งหมดที่ฉันสร้างขึ้น นอกจากนี้ เนื้อหาที่ได้รับการคุ้มครองโดยสิทธิ์ในทรัพย์สินทางปัญญา เช่น ภาพถ่ายและวิดีโอ (เนื้อหา IP) คุณรับรองและรับประกันว่าเนื้อหาดังกล่าวจะเป็นผลงานต้นฉบับของ คุณและเนื้อหาจะไม่ละเมิดหรือยักยอกสิทธิ์ในทรัพย์สินทางปัญญาของบุคคลที่สามใดๆ</li>
      <li>ฉันจะส่งการจ่ายเงินของฉันและสถิติโพสต์ทั้งหมดบน https://app.getkobe.com/ เมื่องานเสร็จสิ้นเพื่อดำเนินการชำระเงิน การชำระเงินจะได้รับภายใน 45 วันหลังจากส่งการชำระเงินบนแพลตฟอร์มและ/หรือการตรวจสอบการชำระเงินจากลูกค้า ขึ้นอยู่กับว่ากรณีใดจะถึงก่อน</li>
      <li>เมื่อฉันได้รับการยืนยันบรีฟแล้ว ฉันจะส่งแบบร่างทั้งหมดภายในเวลาที่กำหนดและเป็นไปตามแนวทางที่ร้องขอจากลูกค้า ฉันจะตรวจสอบให้แน่ใจว่าโพสต์นั้นเผยแพร่ตามวันที่กำหนด และเข้าใจว่าหากไม่เป็นไปตามนั้น หรือลูกค้ามีข้อร้องเรียนเกี่ยวกับผลงานของฉัน ฉันอาจเสียอัตราหรือถูกลูกค้าหักค่าปรับ</li>
      <li>หากผลิตภัณฑ์ถูกรวมไว้ในแคมเปญ ไม่ควรรวมไว้เพื่อวัตถุประสงค์ในการขายหรือขายต่อ</li>
    </ol>`,
    vn: `
    <ol>
      <li>Tôi đã đọc và chấp nhận các điều khoản sử dụng (https://www.getkobe.com/infuencer-terms-use-agreement/)</li>
      <li>Tôi đảm bảo rằng hiện tại tôi không bị lôi kéo vào bất kỳ tranh cãi hoặc tranh chấp pháp lý nào có thể ảnh hưởng tiêu cực đến danh tiếng của tôi hoặc danh tiếng của Kobe hoặc Khách hàng của Kobe. Tôi cũng đồng ý hành xử theo cách phù hợp với các giá trị về tính chuyên nghiệp, tính chính trực và lễ độ. Kobe có quyền chấm dứt bất kỳ Thỏa thuận Chiến dịch nào với Người tạo nội dung bị phát hiện vi phạm điều khoản này và việc chấm dứt đó có thể dẫn đến việc mất mọi khoản bồi thường hoặc lợi ích theo thỏa thuận.</li>
      <li>Tôi đồng ý rằng mọi nội dung được gửi tới Kobe theo Thỏa thuận Chiến dịch và được Khách hàng chấp nhận sẽ vẫn có thể truy cập công khai thông qua (các) tài khoản mạng xã hội của bạn trong tối thiểu sáu (6) tháng hoặc thời hạn lâu hơn như được quy định trong Thỏa thuận Chiến dịch.</li>
      <li>Tôi sở hữu tất cả nội dung và thông tin tôi tạo, ngoài ra, nội dung được bảo vệ bởi quyền sở hữu trí tuệ, như ảnh và video (nội dung IP), Bạn tuyên bố và đảm bảo rằng nội dung đó sẽ là tác phẩm gốc của bạn và nội dung đó sẽ không vi phạm hoặc chiếm dụng quyền sở hữu trí tuệ của bất kỳ bên thứ ba nào.</li>
      <li>Tôi sẽ gửi khoản thanh toán của mình và tất cả số liệu thống kê về bài đăng trên https://app.getkobe.com/ sau khi công việc hoàn thành để thanh toán được xử lý. Khoản thanh toán sẽ được nhận trong vòng 45 ngày sau khi gửi khoản thanh toán trên nền tảng và/hoặc xác nhận thanh toán từ khách hàng, tùy theo thời điểm nào đến trước.</li>
      <li>Sau khi nhận được xác nhận về bản tóm tắt, tôi sẽ gửi tất cả các bản nháp một cách kịp thời và theo hướng dẫn được yêu cầu từ khách hàng. Tôi sẽ đảm bảo bài đăng được hiển thị đúng hạn và hiểu rằng nếu điều này không được đáp ứng hoặc khách hàng có bất kỳ khiếu nại nào về hiệu suất của tôi, tôi có thể bị mất mức giá của mình hoặc bị khách hàng khấu trừ một hình phạt.</li>
      <li>Nếu sản phẩm được đưa vào chiến dịch thì không nên đưa chúng vào mục đích bán hoặc bán lại.</li>
    </ol>`,
    id: `
    <ol>
      <li>Saya telah membaca dan menerima ketentuan penggunaan (https://www.getkobe.com/infuencer-terms-use-agreement/)</li>
      <li>Saya menjamin bahwa saat ini saya tidak terlibat dalam kontroversi atau perselisihan hukum apa pun yang dapat berdampak negatif terhadap reputasi saya atau reputasi Kobe atau Kliennya. Saya selanjutnya setuju untuk berperilaku sesuai dengan nilai-nilai profesionalisme, integritas, dan kesopanan. Kobe berhak mengakhiri Perjanjian Campaign apa pun dengan Pembuat Konten yang ditemukan melanggar klausul ini, dan penghentian tersebut dapat mengakibatkan hilangnya kompensasi atau manfaat apa pun berdasarkan perjanjian.</li>
      <li>Saya setuju bahwa konten apa pun yang dikirimkan ke Kobe berdasarkan Perjanjian Campaign dan diterima oleh Klien akan tetap dapat diakses publik melalui akun media sosial Anda selama minimal enam (6) bulan, atau jangka waktu lebih lama sebagaimana ditentukan dalam Perjanjian Kampanye.</li>
      <li>Saya memiliki seluruh konten dan informasi yang saya buat, selain itu, konten yang dilindungi oleh hak kekayaan intelektual, seperti foto dan video (konten IP), Anda dengan ini menyatakan dan menjamin bahwa konten tersebut merupakan karya asli Anda dan bahwa konten tersebut tidak akan melanggar atau menyalahgunakan hak kekayaan intelektual pihak ketiga mana pun.</li>
      <li>Saya akan mengirimkan pembayaran saya dan semua statistik postingan di https://app.getkobe.com/ setelah pekerjaan selesai agar pembayaran dapat diproses. Pembayaran akan diterima dalam waktu 45 hari setelah penyerahan pembayaran pada platform dan/atau izin pembayaran dari klien, mana yang lebih dulu.</li>
      <li>Setelah saya menerima konfirmasi brief, saya akan menyerahkan semua draft tepat waktu dan sesuai dengan pedoman yang diminta dari klien. Saya akan memastikan postingan tersebut ditayangkan pada tanggal tenggat waktu dan memahami jika hal ini tidak dipenuhi, atau klien memiliki keluhan tentang kinerja saya, saya dapat kehilangan tarif saya atau dikenakan penalti oleh klien.</li>
      <li>Jika produk disertakan dalam campaign, produk tersebut tidak boleh disertakan untuk tujuan dijual atau dijual kembali.</li>
    </ol>`,
    cn: `
    <ol>
      <li>我已阅读并接受了使用条款（https://www.getkobe.com/infuencer-terms-use-agreement/）</li>
      <li>我保证我目前没有参与可能会对我的声誉或Kobe及其客户的声誉造成负面影响的任何争议或法律纠纷。我进一步同意以专业、诚信和得体的方式行事。Kobe保留终止任何发现违反本条款的内容创作者的活动协议的权利，此类终止可能导致协议下的任何补偿或福利的没收。</li>
      <li>我同意根据活动协议向Kobe提交并被客户接受的任何内容都将通过您的社交媒体账户保持公开可访问，最短保留期为六（6）个月，或者在活动协议中指定的更长期限内。</li>
      <li>我拥有我所创建的所有内容和信息，此外，涵盖知识产权的内容，如照片和视频（IP内容），您在此声明并保证该内容将是您的原创作品，并且该内容不会侵犯或挪用任何第三方的知识产权</li>
      <li>一旦工作完成，我将在https://app.getkobe.com/提交我的支付和所有发布统计数据，以便进行支付处理。支付将在平台上提交支付后的45天内收到，并/或在客户支付清算之后收到，以较早者为准。</li>
      <li>一旦我收到简报的确认，我将按照客户要求的指南及时提交所有草稿。我将确保帖子在截止日期之前上线，并且了解如果未能达到这一要求，或者客户对我的表现有任何投诉，我可能会放弃我的费用或被客户扣罚。</li>
      <li>如果产品被纳入活动中，则不得将其用于销售或转售。</li>
    </ol>`
  },
  confirmButtonText: 'Accept',
  cancelButtonText: 'Decline'
}
const langs = {
  en: {
    name: 'Name',
    email: 'Email',
    dateOfBirth: 'Date of Birth',
    ethnicity: 'Ethnicity',
    country: 'Country',
    occupation: 'Occupation',
    city: 'City',
    gender: 'Gender',
    ContactNo: 'Contact Number',
    instagramHandle: 'Instagram Handle (Leave blank if not applicable)',
    igFollowerCount: 'Instagram Followers (Enter numbers only)',
    igAvgViews: 'Average Instagram Views ',
    tiktokHandle: 'TikTok Handle (Leave blank if not applicable)',
    tiktokFollowerCount: 'TikTok Followers (Enter numbers only)',
    linkedinHandle: 'LinkedIn Handle (Leave blank if not applicable)',
    linkedinFollowerCount: 'Followers (Connections) - Enter numbers only',
    linkedin: 'LinkedIn Post',
    twitterHandle: 'X (Twitter) Handle (Leave blank if not applicable)',
    twitterFollowerCount: 'X (Twitter) Followers (Enter numbers only)',
    twitter: 'X (Twitter) Post',
    facebookHandle: 'Facebook Handle (Leave blank if not applicable)',
    facebookFollowerCount: 'Facebook Followers (Enter numbers only)',
    facebook: 'Facebook Post',
    youtubeHandle: 'YouTube Handle (Leave blank if not applicable)',
    youtubeFollowerCount: 'YouTube Followers (Enter numbers only)',
    youtube: 'YouTube Post',
    twitchHandle: 'Twitch Handle (Leave blank if not applicable)',
    twitchFollowerCount: 'Twitch Followers (Enter numbers only)',
    twitch: 'Twitch Post',
    tiktokAvgViews: 'Average TikTok Views',
    igIndicateCost: 'Please indicate your cost for Instagram',
    igStory: 'IG Story',
    igPost: 'IG Post',
    igCarousel: 'IG Carousel',
    igReel: 'IG Reel',
    igRemarks: 'IG Remarks',
    tiktokRemarks: 'TikTok Remarks',
    tiktokIndicateCost: 'Please indicate your cost for TikTok',
    tiktok: 'TikTok',
    platforms: 'Add Other Social Media Platforms',
    eventAppearance: 'Event Attendance',
    loadingFee: 'Loading Fee',
    uploadMediaKit: 'Upload Your Media Kit here',
    loadContent: 'The Client may be looking to load your content on social media for a duration not more than 30 days, are you agreeable to this arrangement?',
    yes: 'Yes',
    no: 'No, please provide reason ',
    giftBrand: 'Would you like to be part of our PR or gifting collaborations with brands?',
    yesIAm: 'Yes, I am',
    noPaidCampaign: 'No, I only do paid campaigns ',
    preferredCampaigns: 'Preferred type of campaigns/genre (please tick relevant)',
    bestRepresent: 'A short description of your profile that best represents you',
    enterIgTikTok: 'Please enter at least one social media handle'
  },
  th: {
    name: 'ชื่อจริง นามสกุล',
    email: 'อีเมลล์',
    dateOfBirth: 'วันเ ดือน ปีเกิด',
    ethnicity: 'เชื้อชาติ',
    country: 'ประเทศ',
    occupation: 'อาชีพ',
    city: 'เมือง',
    gender: 'เพศ',
    ContactNo: 'เบอร์ติดต่อ',
    instagramHandle: 'ชื่อ ไอจี หรือ ลิ้งไอจี (กรุณาเว้นว่างหากไม่เกี่ยวข้อง)',
    igFollowerCount: 'ผู้ติดตามในไอจี (กรุณาใส่เฉพาะตัวเลขเท่านั้น)',
    igAvgViews: 'ค่าเฉลี่ยเปอร์เซ็นจำนวนคนดูใน IG',
    tiktokHandle: 'ชื่อหรือลิ้งTiktok (กรุณาเว้นว่างหากไม่เกี่ยวข้อง)',
    tiktokFollowerCount: 'จำนวนผู้ติดตามในTiktok (กรุณาใส่เฉพาะตัวเลขเท่านั้น)',
    tiktokAvgViews: 'ค่าเฉลี่ยเปอร์เซ็นจำนวนคนดูใน Tiktok',
    igIndicateCost: 'กรุณาเขียนเรทการโพสต์ในช่องทาง IG',
    igStory: 'เรทการโพสต์ ไอจี สตอรี่ ',
    igPost: 'เรทการโพสต์ ไอจี รูป',
    igCarousel: '4-5 รูปต่อ 1 โพสต์',
    igReel: 'เรทการโพสต์ ไอจี reels',
    igRemarks: 'กรุณาแจ้งเงื่อนไขเพิ่มเติม',
    tiktokRemarks: 'กรุณาแจ้งเงื่อนไขเพิ่มเติม',
    tiktokIndicateCost: 'กรุณาเขียนเรทการโพสต์ในช่องทาง Tiktok',
    tiktok: '1 Tiktok โพสต์',
    platforms: 'ช่องทางโซเชี่ลมีเดียอื่นๆ',
    eventAppearance: 'ค่าธรรมเนียมการเดินทาง',
    loadingFee: 'ค่าธรรมเนียมการโหลด',
    uploadMediaKit: 'อัพโหลดคลิปในนี้ค่ะ',
    loadContent: 'ทางลูกค้าอยากที่จะใช้วิดีโอ Content ได้ไหมคะ',
    yes: 'ได้',
    no: 'ไม่ได้ ( เหตุผล )',
    giftBrand: 'คุณอยากที่จะมีส่วนร่วมในการโฆษณา หรือ collab กับแบรนด์ ไหมคะ',
    yesIAm: 'ได้ค่ะ',
    noPaidCampaign: 'ไม่ (รับงานเฉพาะที่จ่ายเงินเท่านั้น)',
    preferredCampaigns: 'ประเภทแคมเปญ/ประเภทที่ต้องการ (โปรดทำเครื่องหมายที่เกี่ยวข้อง)',
    bestRepresent: 'คำอธิบายสั้น ๆ เกี่ยวกับโปรไฟล์ของคุณที่เป็นตัวแทนของคุณได้ดีที่สุด',
    enterIgTikTok: 'กรุณากรอก Instagram หรือ Tiktok Handle'
  },
  vn: {
    name: 'Họ Tên',
    email: 'Email',
    dateOfBirth: 'Ngày sinh',
    ethnicity: 'Dân tộc',
    country: 'Quốc tịch',
    occupation: 'Nghề nghiệp',
    city: 'Thành phố',
    gender: 'Giới tính',
    ContactNo: 'Số điện thoại liên hệ',
    instagramHandle: 'Tên Instagram (Để trống nếu không áp dụng)',
    igFollowerCount: 'Số lượng Follower trên Instagram (Chỉ nhập số)',
    igAvgViews: 'Lượt View trung bình trên Instagram',
    tiktokHandle: 'Tên Tiktok (Để trống nếu không áp dụng)',
    tiktokFollowerCount: 'Số lượng Follower trên Tiktok (Chỉ nhập số)',
    tiktokAvgViews: 'Lượt View trung bình trên Tiktok',
    igIndicateCost: 'Mức giá mong muốn cho các nội dung trên Instagram',
    igStory: 'IG Story',
    igPost: 'IG Post',
    igCarousel: 'IG Carousel',
    igReel: 'IG Reel',
    igRemarks: 'Lưu ý/Ghi chú',
    tiktokRemarks: 'Lưu ý/Ghi chú',
    tiktokIndicateCost: 'Mức giá mong muốn cho các nội dung trên Tiktok',
    tiktok: 'Tiktok',
    platforms: 'Các nền tảng mạng xã hội khác',
    eventAppearance: 'Phí tham dự Event',
    loadingFee: 'Phí đăng tải nội dung (chi phí để boost content)',
    uploadMediaKit: 'Tải lên Chi tiết báo giá của bạn tại đây',
    loadContent: 'Khách hàng có thể muốn đăng tải nội dung của bạn lên các mạng xã hội trong thời gian không quá 30 ngày, bạn có đồng ý với sự sắp xếp này không?',
    yes: 'Đồng ý',
    no: 'Không đồng ý (Lý do)',
    giftBrand: 'Bạn có muốn tham gia chương trình PR hoặc hợp tác tặng quà của chúng tôi với các thương hiệu không?h',
    yesIAm: 'Đồng ý',
    noPaidCampaign: 'Không, mình chỉ tham gia các chiến dịch trả phí',
    preferredCampaigns: ' Loại chiến dịch/thể loại ưa thích (vui lòng đánh dấu vào ô phù hợp)',
    bestRepresent: 'Một mô tả ngắn gọn về hồ sơ của bạn giúp hình dung bạn tốt nhất',
    enterIgTikTok: 'Vui lòng nhập Nick Instagram hoặc Tiktok'
  },
  id: {
    name: 'Nama',
    email: 'Email',
    dateOfBirth: 'Tanggal Lahir',
    ethnicity: 'Etnis',
    country: 'Negara',
    occupation: 'Pekerjaan',
    city: 'Kota',
    gender: 'Gender',
    ContactNo: 'Nomor Kontak',
    instagramHandle: 'Instagram (Biarkan kosong jika tidak berlaku)',
    igFollowerCount: 'Jumlah Pengikut Instagram (Masukkan hanya angka)',
    igAvgViews: 'Rerata Views Instagram',
    tiktokHandle: 'TikTok (Biarkan kosong jika tidak berlaku)',
    tiktokFollowerCount: 'Jumlah Pengikut TikTok (Masukkan hanya angka)',
    tiktokAvgViews: 'Rerata Views TikTok',
    igIndicateCost: 'Biaya untuk Instagram',
    igStory: 'IG Story',
    igPost: 'IG Post',
    igCarousel: 'IG Carousel',
    igReel: 'IG Reel',
    igRemarks: 'Keterangan',
    tiktokRemarks: 'Keterangan',
    tiktokIndicateCost: 'Biaya untuk Tiktok',
    tiktok: 'TikTok',
    platforms: 'Tambahkan Platform Media Sosial Lainnya',
    eventAppearance: 'Biaya Peserta Acara',
    loadingFee: 'Biaya Pemuatan',
    uploadMediaKit: 'Unggah Peralatan Media Anda Disini',
    loadContent: 'Klien mungkin ingin memuat konten Anda di media sosial untuk jangka waktu tidak lebih dari 30 hari, apakah Anda menyetujuinya?',
    yes: 'Ya',
    no: 'Tidak, tolong jelaskan alasan',
    giftBrand: 'Apakah Anda ingin menjadi bagian dari PR kami atau memberikan kolaborasi dengan brand?',
    yesIAm: 'Ya',
    noPaidCampaign: 'Tidak, saya hanya melakukan campaign berbayar',
    preferredCampaigns: 'Jenis campaign/genre pilihan (harap centang yang relevan)',
    bestRepresent: 'Deskripsi singkat tentang profil Anda yang paling mewakili Anda',
    enterIgTikTok: 'Silakan masukkan Instagram atau Tiktok*'
  },
  cn: {
    name: '姓名',
    email: '电子邮件',
    dateOfBirth: '出生日期',
    ethnicity: '种族',
    country: '国家',
    occupation: '职业',
    city: '城市',
    gender: '性别',
    ContactNo: '联系电话',
    instagramHandle: 'Instagram用户名 (若不适用，请留空)',
    igFollowerCount: '您的Instagram粉丝数量 (只输入数字)',
    igAvgViews: '平均Instagram观看次数',
    tiktokHandle: 'TikTok用户名 (若不适用，请留空)',
    tiktokFollowerCount: '您的TikTok粉丝数量 (只输入数字)',
    tiktokAvgViews: '平均TikTok观看次数',
    igIndicateCost: '请注明您的Instagram价格',
    igStory: 'IG Story',
    igPost: 'IG Post',
    igCarousel: 'IG Carousel',
    igReel: 'IG Reel',
    igRemarks: 'IG Remarks',
    tiktokRemarks: 'TikTok Remarks',
    tiktokIndicateCost: '请注明您的Tiktok价格',
    tiktok: 'TikTok',
    platforms: '添加其他社交媒体平台',
    eventAppearance: '活动参与费',
    loadingFee: '加载费用',
    uploadMediaKit: '在此上传您的媒体宣传册',
    loadContent: '客户可能希望将您的内容加载到社交媒体上，但不超过30天，请问您是否同意此安排？',
    yes: '好',
    no: '否，请提供原因',
    giftBrand: '你想参与我们与品牌的公关或赠品合作吗？',
    yesIAm: '是的，我愿意',
    noPaidCampaign: '不，我只做付费活动',
    preferredCampaigns: '首选的活动/类型（请勾选相关项',
    bestRepresent: '请简要描述您的资料，以最能代表您的方式。',
    enterIgTikTok: '请填写Instagram或Tiktok用户名'
  }
}
export default Object.assign({}, {
  formConfig,
  tableHeaders,
  followerOptions,
  rateCardTermsAndCondition,
  langs,
  rateCardLabels,
  currencyOptions
})



// WEBPACK FOOTER //
// ./src/components/views/Influencer/RateCard/config.js